import React, { useEffect, useMemo, useState } from "react";
import { ARRProvider } from "../../../features/ARR/context/ARRLevelContext";
import Sidebar from "../../../features/ARR/components/shared/Sidebar";
import "./../../../features/ARR/styles/arr.scss";

const ARRContainer = ({ contents, name, ARR, isNewModule }) => {
  const [widgetContents, setWidgetContents] = useState(contents);
  const [activeTab, setActiveTab] = useState("");
  //using name for tab currently as publish report and template having same code is causing problem

  const activeContent = useMemo(() => {
    return widgetContents
      ?.flatMap((content) => content.tabs)
      ?.find((tab) => tab.name === activeTab);
  }, [widgetContents, activeTab]);

  useEffect(() => {
    setActiveTab(widgetContents[0]?.tabs[0]?.name);
  }, [widgetContents]);

  return (
    <ARRProvider>
      <div
        style={{ height: "100%" }}
        className={`${name.includes("ARR") || isNewModule ? "arr-widget-container" : ""}`}
      >
        <Sidebar
          name={name}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          widgetContents={widgetContents}
          setWidgetContents={setWidgetContents}
          permittedARR={ARR}
        />

        <>{activeContent?.content}</>
      </div>
    </ARRProvider>
  );
};

export default ARRContainer;
